module.exports = __webpack_public_path__ + "static/media/404-failed.dbbcf1d4.svg";